import { Palette, Check } from 'lucide-react';
import { useTheme, UI_STYLES } from '../lib/theme';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
    DropdownMenuSeparator, DropdownMenuTrigger,
} from './ui/dropdown-menu';

const SWATCHES = {
    terminal: ['#050505', '#00FF41'],
    dossier: ['#F7F3EC', '#8B1E1E'],
    evidence: ['#2A231B', '#E0353C'],
};

export default function StyleSwitcher() {
    const { uiStyle, setUiStyle } = useTheme();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button type="button" data-testid="style-switcher-btn" title="Cambia grafica"
                    className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-[#00FF41]/50 transition-colors">
                    <Palette className="w-4 h-4 text-[#00FF41]" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-64" data-testid="style-switcher-menu">
                <DropdownMenuLabel>Grafica dell'app</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {UI_STYLES.map(s => (
                    <DropdownMenuItem key={s.id} data-testid={`style-option-${s.id}`}
                        onSelect={() => setUiStyle(s.id)} className="flex items-center gap-3 cursor-pointer py-2">
                        <span className="flex shrink-0 border border-black/20">
                            <span className="w-3 h-6" style={{ background: SWATCHES[s.id][0] }} />
                            <span className="w-3 h-6" style={{ background: SWATCHES[s.id][1] }} />
                        </span>
                        <span className="flex-1 min-w-0">
                            <span className="block text-sm font-medium">{s.label}</span>
                            <span className="block text-xs opacity-60 truncate">{s.description}</span>
                        </span>
                        {uiStyle === s.id && <Check className="w-4 h-4 shrink-0" data-testid={`style-option-${s.id}-active`} />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
